import { render } from "./firstRechargeBonus.vue?vue&type=template&id=4b003d80&scoped=true"
import script from "./firstRechargeBonus.vue?vue&type=script&lang=js"
export * from "./firstRechargeBonus.vue?vue&type=script&lang=js"

import "./firstRechargeBonus.vue?vue&type=style&index=0&id=4b003d80&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b003d80"]])

export default __exports__